// Lightweight moment.js replacement — only supports .format('DD.MM.YYYY')
// Removes 290KB moment.js from the bundle (now 0KB)
const formatDate = (date: string | Date) => ({
  format: (fmt: string) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return fmt
      .replace('DD', String(d.getDate()).padStart(2, '0'))
      .replace('MM', String(d.getMonth() + 1).padStart(2, '0'))
      .replace('YYYY', String(d.getFullYear()));
  },
  diff: (other: string | Date, unit: string) => {
    const diff = d.getTime() - new Date(other).getTime();
    if (unit === 'days') return Math.floor(diff / 86400000);
    if (unit === 'hours') return Math.floor(diff / 3600000);
    return diff;
  },
});

// Fix: reference d outside for diff method
const momentLike = (date: string | Date) => {
  const d = new Date(date);
  return {
    format: (fmt: string) => {
      if (isNaN(d.getTime())) return '';
      return fmt
        .replace('DD', String(d.getDate()).padStart(2, '0'))
        .replace('MM', String(d.getMonth() + 1).padStart(2, '0'))
        .replace('YYYY', String(d.getFullYear()));
    },
    diff: (other: string | Date, unit?: string) => {
      const diff = d.getTime() - new Date(other).getTime();
      if (unit === 'days') return Math.floor(diff / 86400000);
      if (unit === 'hours') return Math.floor(diff / 3600000);
      return diff;
    },
    add: (amount: number, unit: string) => {
      const result = new Date(d);
      if (unit === 'days' || unit === 'd') result.setDate(result.getDate() + amount);
      if (unit === 'months' || unit === 'M') result.setMonth(result.getMonth() + amount);
      if (unit === 'years' || unit === 'y') result.setFullYear(result.getFullYear() + amount);
      return momentLike(result);
    },
    toDate: () => d,
    valueOf: () => d.getTime(),
  };
};

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('moment', momentLike);
});
